import { useMutation } from '@apollo/client';
import { Modal, Switch } from 'antd';
import React, { useState } from 'react';
import { SET_LIBRARY_STAFF_SERVICEABLE } from '../graphql/Mutations';

const AVAILABILITY_LABEL = {
  AVAILABLE: 'Available',
  NOT_AVAILABLE: 'Not Available',
};

const StaffAvailabilitySwitch = ({
  userId,
  isServiceable = false,
  staffLabel = 'staff',
  disabled = false,
  onSuccess,
}) => {
  const [isPromptOpen, setIsPromptOpen] = useState(false);

  const [
    setLibraryStaffServiceable,
    { loading },
  ] = useMutation(SET_LIBRARY_STAFF_SERVICEABLE, { onError: () => {} });

  const handleConfirm = async () => {
    const response = await setLibraryStaffServiceable({
      variables: {
        where: { userId },
        data: { isServiceable: !isServiceable },
      },
    });
    if (response?.data) {
      setIsPromptOpen(false);
      onSuccess?.();
    }
  };

  return (
    <>
      <Switch
        size="small"
        checked={Boolean(isServiceable)}
        disabled={disabled || !userId}
        loading={loading}
        onChange={() => setIsPromptOpen(true)}
      />
      <Modal
        title="Caution"
        okText="Yes"
        cancelText="No"
        open={isPromptOpen}
        onOk={handleConfirm}
        onCancel={() => setIsPromptOpen(false)}
        okButtonProps={{ loading }}
      >
        Are you sure you want to mark this {staffLabel} as
        <strong>
          {' '}
          {isServiceable
            ? AVAILABILITY_LABEL.NOT_AVAILABLE
            : AVAILABILITY_LABEL.AVAILABLE}
        </strong>
        ?
      </Modal>
    </>
  );
};

export default StaffAvailabilitySwitch;
